import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as authActions from '../../ducks/auth';
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import LoginForm from './components/LoginForm';
import LoginByPhone from './components/LoginByPhone';
import ResetPasswordForm from './components/ResetForm';
import RegisterForm from './components/RegisterForm';
import classnames from 'classnames';
import injectSheet from 'react-jss';
import Logo from '../../images/logo_u.jpg';

export class LoginPage extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired
  };

  state = {
    form: 'registration',
    loginType: 'phone',
    tempPasswordSent: false,
    extendedJoin: false
  };

  toggle = () => undefined;

  setForm = form => this.setState({ form });

  setLoginType = loginType => this.setState({ loginType });

  signInSubmit = values => {
    return this.props.actions
      .signIn({
        login: `${values.seria.name}${values.number}`,
        password: values.password,
        remember: values.remember
      })
      .then(this.props.history.replace('/'));
  };

  registerSubmit = values => {
    return this.props.actions
      .register({
        login: `${values.seria.name}${values.number}`,
        passport: values.passport,
        password: values.password
      })
      .then(this.props.history.replace('/extended'));
  };

  resetPasswordSubmit = values => {
    this.setState({ tempPasswordSent: false });
    return this.props.actions
      .passwordRecovery({
        login: `${values.seria.name}${values.number}`
      })
      .then(result => {
        if (result.success) {
          this.setState({ tempPasswordSent: true });
        }
      });
  };

  submitOnEnter = handleSubmit => e => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();
      handleSubmit();
    }
  };

  triggerPassRecoveryMode = () => {
    const { form } = this.state;
    this.setState({
      form: form === 'login' ? 'recovery' : 'login',
      tempPasswordSent: false
    });
  };

  loginByPhoneSubmit = values => {
    return this.props.actions.loginByPhone(values).then(result => {
      if (!!result?.data?.user) {
        this.props.history.replace('/');
      }
    });
  };

  render() {
    const {
      showConsentOnPersonalDataProcessing,
      actions: { confirmConsentOnPersonalDataProcessing }
    } = this.props;
    const { form, tempPasswordSent, loginType } = this.state;

    return (
      <>
        {showConsentOnPersonalDataProcessing && (
          <div className='fixed-bottom w-100 p-4'>
            <div className='bg-white rounded p-3 shadow'>
              <Row>
                <Col>
                  Продолжая пользование настоящим сайтом Вы выражаете своё{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/Consent-to-the-processing-of-personal-data.pdf`}
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    согласие
                  </a>{' '}
                  на обработку Ваших персональных данных. Порядок обработки Ваших персональных
                  данных, а также реализуемые требования к их защите, содержатся в{' '}
                  <a
                    href={`${process.env.PUBLIC_URL}/Politika_obrabotki_personalnyh_dannyh.pdf`}
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    Политике АО «СК «Ю-Лайф»
                  </a>
                  .
                </Col>
                <Col xs='auto'>
                  <Button onClick={confirmConsentOnPersonalDataProcessing}>Закрыть</Button>
                </Col>
              </Row>
            </div>
          </div>
        )}

        <Container fluid>
          <Row>
            <Col
              xl='6'
              lg='6'
              className='col-xxl-4 offset-xxl-4 offset-xl-3 offset-lg-3 mt-3 mb-3 mt-sm-5 pt-sm-5 pb-sm-5'
            >
              <div className='bg-white shadow-lg rounded p-3 p-sm-4'>
                {form === 'recovery' ? (
                  <ResetPasswordForm
                    onSubmit={this.resetPasswordSubmit}
                    triggerPassRecoveryMode={this.triggerPassRecoveryMode}
                    submitOnEnter={this.submitOnEnter}
                    tempPasswordSent={tempPasswordSent}
                  />
                ) : (
                  <React.Fragment>
                    <Row>
                      <Col>
                        <div className='mb-3 d-flex align-items-center justify-content-between flex-wrap-reverse'>
                          <ButtonGroup>
                            <Button
                              color='success'
                              outline={form !== 'login'}
                              onClick={e => this.setForm('login')}
                              size='lg'
                            >
                              Вход
                            </Button>
                            <Button
                              color='success'
                              outline={form !== 'registration'}
                              onClick={e => this.setForm('registration')}
                              size='lg'
                            >
                              Регистрация
                            </Button>
                          </ButtonGroup>
                          <img
                            src={Logo}
                            alt='Югория Жизнь'
                            className='img-fluid ml-0 ml-xl-5 mb-3 mb-sm-0'
                            style={{ maxHeight: 48 }}
                          />
                        </div>
                      </Col>
                    </Row>
                    {form === 'login' && (
                      <>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: loginType === 'phone',
                                'c-pointer': true
                              })}
                              onClick={() => {
                                this.setLoginType('phone');
                              }}
                            >
                              Телефон
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: loginType === 'contract',
                                'c-pointer': true
                              })}
                              onClick={() => {
                                this.setLoginType('contract');
                              }}
                            >
                              Номер договора
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={loginType} className='mt-2'>
                          {loginType === 'phone' && (
                            <TabPane tabId='phone'>
                              <LoginByPhone
                                onSubmit={this.loginByPhoneSubmit}
                                submitOnEnter={this.submitOnEnter}
                                changeNumber={this.props.actions.hideSMSCode}
                              />
                            </TabPane>
                          )}
                          {loginType === 'contract' && (
                            <TabPane tabId='contract'>
                              <LoginForm
                                onSubmit={this.signInSubmit}
                                triggerPassRecoveryMode={this.triggerPassRecoveryMode}
                                submitOnEnter={this.submitOnEnter}
                              />
                            </TabPane>
                          )}
                        </TabContent>
                      </>
                    )}
                    {form === 'registration' && (
                      <RegisterForm
                        onSubmit={this.registerSubmit}
                        triggerPassRecoveryMode={this.triggerPassRecoveryMode}
                        submitOnEnter={this.submitOnEnter}
                        initialValues={{ accept: false }}
                      />
                    )}
                  </React.Fragment>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

function mapStateToProps({ app, auth }) {
  return {
    contractSeries: app.contractSeries,
    showConsentOnPersonalDataProcessing: auth.showConsentOnPersonalDataProcessing
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(authActions, dispatch)
  };
}

const styles = theme => ({
  form: {
    backgroundColor: 'white'
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(LoginPage))
);
